
import React from 'react';

const BillsHeader = () => {
  return (
    <div className="mb-8">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white">My Utility Bills</h1>
      <p className="mt-2 text-lg text-gray-700 dark:text-gray-300">
        Manage your energy bills and payments
      </p>
    </div>
  );
};

export default BillsHeader;
